import React, { useState } from "react";

import {
  FiCalendar,
  FiClock,
  FiMapPin,
  FiUsers,
  FiBriefcase,
  FiGift,
  FiArrowRight,
  FiUser,
  FiBarChart2,
  FiShare2,
  FiCoffee,
} from "react-icons/fi";
import Toast from '../components/Toast/Toast';
import "./Event.css";

import heroImage from "../assets/images/events.png";
import tableImage from "../assets/images/eventad.png";

import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import Button from "../components/Button/Button";

const EventPage = () => {
  /* =====================================================
     ACTIVE TAB
  ===================================================== */

  const [activeTab, setActiveTab] = useState("chro");
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  /* =====================================================
     CHRO FORM STATE
  ===================================================== */

  const [chroForm, setChroForm] = useState({
    name: "",
    organisation: "",
    designation: "",
    email: "",
    mobile: "",
    experience: "",
    expertise: [],
    role: [],
    participation: "",
  });


  /* =====================================================
     TRAINING INSTITUTE FORM STATE
  ===================================================== */

  const [trainingForm, setTrainingForm] = useState({
    name: "",
    instituteName: "",
    designation: "",
    email: "",
    mobile: "",
    experience: "",
    instituteFocus: [],
    representation: [],
    participation: "",
  });


  /* =====================================================
     CHRO INPUT CHANGE
  ===================================================== */

  const handleChroChange = (e) => {
    const { name, value } = e.target;

    setChroForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  /* =====================================================
     TRAINING INPUT CHANGE
  ===================================================== */

  const handleTrainingChange = (e) => {
    const { name, value } = e.target;

    setTrainingForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  /* =====================================================
     CHRO CHECKBOX CHANGE
  ===================================================== */

  const handleChroCheckbox = (e, field) => {
    const { value, checked } = e.target;

    setChroForm((prev) => ({
      ...prev,

      [field]: checked
        ? [...prev[field], value]
        : prev[field].filter((item) => item !== value),
    }));
  };


  /* =====================================================
     TRAINING CHECKBOX CHANGE
  ===================================================== */

  const handleTrainingCheckbox = (e, field) => {
    const { value, checked } = e.target;

    setTrainingForm((prev) => ({
      ...prev,

      [field]: checked
        ? [...prev[field], value]
        : prev[field].filter((item) => item !== value),
    }));
  };


  /* =====================================================
     SUBMIT
  ===================================================== */

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (isSubmitting) return;
  
    try {
      setIsSubmitting(true);
  
      let payload;
  
      if (activeTab === "chro") {
        payload = {
          registrationType: "chro",
  
          name: chroForm.name.trim(),
          organisation: chroForm.organisation.trim(),
          designation: chroForm.designation.trim(),
          email: chroForm.email.trim(),
          mobile: chroForm.mobile.trim(),
  
          chroExperience: chroForm.experience,
  
          expertise: chroForm.expertise,
  
          role: chroForm.role,
  
          participation: chroForm.participation,
        };
      } else {
        payload = {
          registrationType: "trainingInstitute",
  
          name: trainingForm.name.trim(),
          instituteName: trainingForm.instituteName.trim(),
          designation: trainingForm.designation.trim(),
          email: trainingForm.email.trim(),
          mobile: trainingForm.mobile.trim(),
  
          instituteExperience: trainingForm.experience,
  
          instituteFocus: trainingForm.instituteFocus,
  
          representation: trainingForm.representation,
  
          participation: trainingForm.participation,
        };
      }
  
      console.log("Submitting payload:", payload);
  
      const response = await fetch(
        "https://dev.mentorx4u.com/api/event-registrations",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(
          data.message || "Registration failed."
        );
      }
  
      console.log("Registration success:", data);
  
    //   alert(
    //     activeTab === "chro"
    //       ? "Thank you! Your CHRO expression of interest has been submitted."
    //       : "Thank you! Your Training Institute expression of interest has been submitted."
    //   );

      setToastMessage(activeTab === "chro"
        ? "Thank you! Your CHRO expression of interest has been submitted."
        : "Thank you! Your Training Institute expression of interest has been submitted.");
      setToastVisible(true);
  
      // Reset CHRO form
      if (activeTab === "chro") {
        setChroForm({
          name: "",
          organisation: "",
          designation: "",
          email: "",
          mobile: "",
          experience: "",
          expertise: [],
          role: [],
          participation: "",
        });
      }
  
      // Reset Training Institute form
      if (activeTab === "training") {
        setTrainingForm({
          name: "",
          instituteName: "",
          designation: "",
          email: "",
          mobile: "",
          experience: "",
          instituteFocus: [],
          representation: [],
          participation: "",
        });
      }
    } catch (error) {
      console.error("Event registration error:", error.message);
  
     
      setToastMessage(error.message);
      setToastVisible(true);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="event-page">

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <Navbar />


      {/* =====================================================
          HERO SECTION
      ===================================================== */}

      <section
        className="event-hero"
        style={{
          backgroundImage: `url(${heroImage})`,
        }}
      >

        <div className="event-hero-overlay"></div>

        <div className="event-hero-content">

          <div className="hero-left">

            <h1>
              The best HR
              <br />
              conversations don’t
              <br />
              happen on a stage.
              <br />
              They happen
              <br />
              around the table.
            </h1>

            <div className="hero-line"></div>

            <p className="hero-description">
              An intimate CHRO round-table bringing senior HR
              leaders and training partners together to exchange
              perspectives on skills, talent, hiring and the future
              of work.
            </p>


            {/* EVENT INFORMATION */}

            <div className="event-meta">

              {/* DATE */}

              <div className="event-meta-item">

                <FiCalendar size={21} />

                <div>
                  <span>31 October</span>
                  <small>2026</small>
                </div>

              </div>


              {/* TIME */}

              <div className="event-meta-item">

                <FiClock size={21} />

                <div>
                  <span>7:00 PM</span>
                  <small>(Onwards)</small>
                </div>

              </div>


              {/* LOCATION */}

              <div className="event-meta-item">

                <FiMapPin size={21} />

                <div>
                  <span>Bengaluru</span>
                </div>

              </div>


              {/* DURATION */}

              <div className="event-meta-item">

                <FiUsers size={21} />

                <div>
                  <span>1 – 2 Hours</span>
                </div>

              </div>


              {/* SEATS */}

              <div className="event-meta-item">

                <FiBriefcase size={21} />

                <div>
                  <span>Limited</span>
                  <small>Seats</small>
                </div>

              </div>

            </div>


            {/* HERO BUTTON */}

            {/* <a
              href="#register"
              className="hero-interest-btn"
            >
              EXPRESS YOUR INTEREST

              <FiArrowRight size={18} />
            </a> */}
  <Button  variant="hero" to="#register">
              START YOUR JOURNEY
            </Button>
          </div>

        </div>

      </section>


      {/* =====================================================
          WHY THIS CONVERSATION
      ===================================================== */}

      <section
        className="conversation-section"
        id="why-join"
      >

        <div className="container">

          <div className="section-heading">

            <span>
              WHY THIS CONVERSATION?
            </span>

            <h2>
              A focused evening. Real perspectives. Lasting value.
            </h2>

          </div>


          {/* BENEFITS */}

          <div className="benefits-grid">


            {/* CARD 1 */}

            <div className="benefit-card">

              <div className="benefit-icon">
                <FiUser size={27} />
              </div>

              <h3>
                Peer perspectives
              </h3>

              <p>
                Exchange ideas with fellow CHROs and senior HR
                leaders across industries.
              </p>

            </div>


            {/* CARD 2 */}

            <div className="benefit-card">

              <div className="benefit-icon purple">
                <FiBarChart2 size={27} />
              </div>

              <h3>
                Industry insights
              </h3>

              <p>
                Discuss emerging trends in skills, talent, hiring
                and the future of work.
              </p>

            </div>


            {/* CARD 3 */}

            <div className="benefit-card">

              <div className="benefit-icon orange">
                <FiShare2 size={27} />
              </div>

              <h3>
                Meaningful connections
              </h3>

              <p>
                Build relationships with like-minded HR leaders
                and training partners.
              </p>

            </div>


            {/* CARD 4 */}

            <div className="benefit-card">

              <div className="benefit-icon blue">
                <FiCoffee size={27} />
              </div>

              <h3>
                An intimate format
              </h3>

              <p>
                A small, curated round-table with light
                refreshments and dinner served.
              </p>

            </div>

          </div>


          {/* APPRECIATION */}

          <div className="appreciation-box">

            <div className="gift-icon">
              <FiGift size={29} />
            </div>

            <div>

              <strong>
                We value your time and perspective.
              </strong>

              <p>
                A small gratification will be provided to all
                confirmed participants as a token of appreciation.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          REGISTRATION SECTION
      ===================================================== */}

      <section
        className="registration-section"
        id="register"
      >

        <div className="registration-container">


          {/* =================================================
              LEFT IMAGE
          ================================================= */}

          <div
            className="registration-image"
            style={{
              backgroundImage: `url(${tableImage})`,
            }}
          >

            <div className="registration-image-overlay"></div>

            <div className="registration-image-content">

              <span>
                {activeTab === "chro"
                  ? "CHRO ROUND-TABLE"
                  : "TRAINING INSTITUTE"}
              </span>

              <h2>
                Join the
                <br />
                Conversation
              </h2>

              <div className="small-line"></div>

              <p>
                {activeTab === "chro"
                  ? "Help us understand your background and interests so we can curate a meaningful and engaging round-table discussion."
                  : "Help us understand your institute and interests so we can curate a meaningful and engaging round-table discussion."}
              </p>

            </div>

          </div>


          {/* =================================================
              RIGHT FORM
          ================================================= */}

          <div className="registration-form-wrapper">


            {/* =================================================
                REGISTRATION TABS
            ================================================= */}

            <div className="registration-tabs">

              <button
                type="button"
                className={`registration-tab ${
                  activeTab === "chro"
                    ? "active"
                    : ""
                }`}
                onClick={() => setActiveTab("chro")}
              >
                CHROs
              </button>


              <button
                type="button"
                className={`registration-tab ${
                  activeTab === "training"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setActiveTab("training")
                }
              >
                Training Institute
              </button>

            </div>


            {/* =================================================
                FORM
            ================================================= */}

            <form onSubmit={handleSubmit}>


              {/* =================================================
                  CHRO FORM
              ================================================= */}

              {activeTab === "chro" && (
                <>

                  {/* ===========================================
                      1. YOUR DETAILS
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>1.</span> YOUR DETAILS
                    </div>


                    <div className="form-grid two">


                      {/* NAME */}

                      <div className="form-group">

                        <label>
                          Name <sup>*</sup>
                        </label>

                        <input
                          type="text"
                          name="name"
                          placeholder="Enter your full name"
                          value={chroForm.name}
                          onChange={handleChroChange}
                          required
                        />

                      </div>


                      {/* ORGANISATION */}

                      <div className="form-group">

                        <label>
                          Current Organisation <sup>*</sup>
                        </label>

                        <input
                          type="text"
                          name="organisation"
                          placeholder="Enter your organisation"
                          value={chroForm.organisation}
                          onChange={handleChroChange}
                          required
                        />

                      </div>

                    </div>


                    <div className="form-grid three">


                      {/* DESIGNATION */}

                      <div className="form-group">

                        <label>
                          Designation <sup>*</sup>
                        </label>

                        <input
                          type="text"
                          name="designation"
                          placeholder="Enter your designation"
                          value={chroForm.designation}
                          onChange={handleChroChange}
                          required
                        />

                      </div>


                      {/* EMAIL */}

                      <div className="form-group">

                        <label>
                          Email <sup>*</sup>
                        </label>

                        <input
                          type="email"
                          name="email"
                          placeholder="Enter your email address"
                          value={chroForm.email}
                          onChange={handleChroChange}
                          required
                        />

                      </div>


                      {/* MOBILE */}

                      <div className="form-group">

                        <label>
                          Mobile Number <sup>*</sup>
                        </label>

                        <input
                          type="tel"
                          name="mobile"
                          placeholder="Enter your mobile number"
                          value={chroForm.mobile}
                          onChange={handleChroChange}
                          required
                        />

                      </div>

                    </div>

                  </div>


                  {/* ===========================================
                      2. EXPERIENCE
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>2.</span> EXPERIENCE
                    </div>


                    <p className="question">
                      How many years of professional experience
                      do you have? <sup>*</sup>
                    </p>


                    <div className="radio-row">

                      {[
                        "10 to 15 years",
                        "15 to 20 years",
                        "20 to 25 years",
                        "25+ years",
                      ].map((item) => (

                        <label
                          className="radio-option"
                          key={item}
                        >

                          <input
                            type="radio"
                            name="experience"
                            value={item}
                            checked={
                              chroForm.experience === item
                            }
                            onChange={handleChroChange}
                            required
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>


                  {/* ===========================================
                      3. YOUR AREA OF EXPERTISE
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>3.</span> YOUR AREA OF EXPERTISE
                    </div>


                    <p className="question">
                      Which topics would you be most comfortable
                      sharing your perspective on?
                    </p>


                    <div className="checkbox-grid">

                      {[
                        "Future Skills and Employability",
                        "Hiring Trends and Industry Expectations",
                        "Leadership and Workplace Readiness",
                        "Talent Development and Upskilling",
                        "AI and the Future of Work",
                      ].map((item) => (

                        <label
                          className="checkbox-option"
                          key={item}
                        >

                          <input
                            type="checkbox"
                            value={item}
                            checked={
                              chroForm.expertise.includes(item)
                            }
                            onChange={(e) =>
                              handleChroCheckbox(
                                e,
                                "expertise"
                              )
                            }
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>


                  {/* ===========================================
                      4. YOUR ROLE IN THE CONVERSATION
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>4.</span> YOUR ROLE IN THE CONVERSATION
                    </div>


                    <p className="question">
                      Which best describes your current involvement?
                    </p>


                    <div className="checkbox-grid">

                      {[
                        "Workforce / Talent Strategy",
                        "Recruitment and Hiring",
                        "Learning and Development",
                        "Leadership Development",
                        "Employer Branding / Talent Attraction",
                        "Other",
                      ].map((item) => (

                        <label
                          className="checkbox-option"
                          key={item}
                        >

                          <input
                            type="checkbox"
                            value={item}
                            checked={
                              chroForm.role.includes(item)
                            }
                            onChange={(e) =>
                              handleChroCheckbox(
                                e,
                                "role"
                              )
                            }
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>


                  {/* ===========================================
                      5. EVENT PARTICIPATION
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>5.</span> EVENT PARTICIPATION
                    </div>


                    <p className="event-note">
                      The event is planned for 31 October 2026
                      at approximately 7:00 PM in Bengaluru,
                      with the evening expected to run for
                      approximately 1 to 2 hours.
                    </p>


                    <p className="question">
                      Would you be willing to attend the event
                      in person and share your experience and
                      perspective with the participating training
                      institutes and talent?
                    </p>


                    <div className="participation-options">

                      {[
                        "Yes, I would be happy to attend",
                        "I would like more details before confirming",
                        "Unable to attend",
                      ].map((item) => (

                        <label
                          className="radio-option"
                          key={item}
                        >

                          <input
                            type="radio"
                            name="participation"
                            value={item}
                            checked={
                              chroForm.participation === item
                            }
                            onChange={handleChroChange}
                            required
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>

                </>
              )}


              {/* =================================================
                  TRAINING INSTITUTE FORM
              ================================================= */}

              {activeTab === "training" && (
                <>

                  {/* ===========================================
                      1. YOUR DETAILS
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>1.</span> YOUR DETAILS
                    </div>


                    <div className="form-grid two">


                      {/* NAME */}

                      <div className="form-group">

                        <label>
                          Name <sup>*</sup>
                        </label>

                        <input
                          type="text"
                          name="name"
                          placeholder="Enter your full name"
                          value={trainingForm.name}
                          onChange={handleTrainingChange}
                          required
                        />

                      </div>


                      {/* INSTITUTE NAME */}

                      <div className="form-group">

                        <label>
                          Institute Name <sup>*</sup>
                        </label>

                        <input
                          type="text"
                          name="instituteName"
                          placeholder="Enter institute name"
                          value={trainingForm.instituteName}
                          onChange={handleTrainingChange}
                          required
                        />

                      </div>

                    </div>


                    <div className="form-grid three">


                      {/* DESIGNATION */}

                      <div className="form-group">

                        <label>
                          Designation <sup>*</sup>
                        </label>

                        <input
                          type="text"
                          name="designation"
                          placeholder="Enter your designation"
                          value={trainingForm.designation}
                          onChange={handleTrainingChange}
                          required
                        />

                      </div>


                      {/* EMAIL */}

                      <div className="form-group">

                        <label>
                          Email <sup>*</sup>
                        </label>

                        <input
                          type="email"
                          name="email"
                          placeholder="Enter your email address"
                          value={trainingForm.email}
                          onChange={handleTrainingChange}
                          required
                        />

                      </div>


                      {/* MOBILE */}

                      <div className="form-group">

                        <label>
                          Mobile Number <sup>*</sup>
                        </label>

                        <input
                          type="tel"
                          name="mobile"
                          placeholder="Enter your mobile number"
                          value={trainingForm.mobile}
                          onChange={handleTrainingChange}
                          required
                        />

                      </div>

                    </div>

                  </div>


                  {/* ===========================================
                      2. EXPERIENCE
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>2.</span> EXPERIENCE
                    </div>


                    <p className="question">
                      How many years have you been involved in
                      the education, training or skilling industry?
                      <sup>*</sup>
                    </p>


                    <div className="radio-row">

                      {[
                        "Under 5 years",
                        "5 to 10 years",
                        "10 to 15 years",
                        "15+ years",
                      ].map((item) => (

                        <label
                          className="radio-option"
                          key={item}
                        >

                          <input
                            type="radio"
                            name="experience"
                            value={item}
                            checked={
                              trainingForm.experience === item
                            }
                            onChange={handleTrainingChange}
                            required
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>


                  {/* ===========================================
                      3. YOUR INSTITUTE FOCUS
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>3.</span> YOUR INSTITUTE FOCUS
                    </div>


                    <p className="question">
                      Which areas does your institute primarily
                      operate in?
                    </p>


                    <div className="checkbox-grid">

                      {[
                        "Technology and IT Skills",
                        "Management and Business Skills",
                        "Professional / Employability Skills",
                        "Vocational / Technical Training",
                        "Other",
                      ].map((item) => (

                        <label
                          className="checkbox-option"
                          key={item}
                        >

                          <input
                            type="checkbox"
                            value={item}
                            checked={
                              trainingForm.instituteFocus.includes(
                                item
                              )
                            }
                            onChange={(e) =>
                              handleTrainingCheckbox(
                                e,
                                "instituteFocus"
                              )
                            }
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>


                  {/* ===========================================
                      4. WHAT WOULD YOU REPRESENT
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>4.</span> WHAT WOULD YOU REPRESENT
                      AT THE CONVERSATION?
                    </div>


                    <p className="question">
                      Which topics would you be most interested
                      in discussing with CHROs?
                    </p>


                    <div className="checkbox-grid">

                      {[
                        "Industry Ready Skills",
                        "Employer Expectations and Placement Requirements",
                        "Curriculum and Training Relevance",
                        "Candidate Employability and Placement Readiness",
                        "Industry Partnerships and Hiring Connect",
                      ].map((item) => (

                        <label
                          className="checkbox-option"
                          key={item}
                        >

                          <input
                            type="checkbox"
                            value={item}
                            checked={
                              trainingForm.representation.includes(
                                item
                              )
                            }
                            onChange={(e) =>
                              handleTrainingCheckbox(
                                e,
                                "representation"
                              )
                            }
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>


                  {/* ===========================================
                      5. EVENT PARTICIPATION
                  =========================================== */}

                  <div className="form-section">

                    <div className="form-section-title">
                      <span>5.</span> EVENT PARTICIPATION
                    </div>


                    <p className="event-note">
                      The event is planned for 31 October 2026
                      at approximately 7:00 PM in Bengaluru,
                      with the evening expected to run for
                      approximately 1 to 2 hours.
                    </p>


                    <p className="question">
                      Would you be willing to attend in person
                      and participate in a focused conversation
                      with CHROs and senior HR leaders?
                    </p>


                    <div className="participation-options">

                      {[
                        "Yes, I would be happy to attend",
                        "I would like more details before confirming",
                        "Unable to attend",
                      ].map((item) => (

                        <label
                          className="radio-option"
                          key={item}
                        >

                          <input
                            type="radio"
                            name="trainingParticipation"
                            value={item}
                            checked={
                              trainingForm.participation === item
                            }
                            onChange={(e) =>
                              setTrainingForm((prev) => ({
                                ...prev,
                                participation: e.target.value,
                              }))
                            }
                            required
                          />

                          <span>
                            {item}
                          </span>

                        </label>

                      ))}

                    </div>

                  </div>

                </>
              )}


              {/* =================================================
                  SUBMIT BUTTON
              ================================================= */}

              {/* <button
                type="submit"
                className="submit-btn"
              >

                SUBMIT & EXPRESS INTEREST

                <FiArrowRight size={19} />

              </button> */}

<Button
  type="submit"
  variant="teal"
  disabled={isSubmitting}
>
  {isSubmitting
    ? "SUBMITTING..."
    : "SUBMIT & EXPRESS INTEREST"}
</Button>

            </form>

          </div>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}

      <Footer />
      <Toast 
        message={toastMessage} 
        isVisible={toastVisible} 
        onClose={() => setToastVisible(false)} 
      />
    </div>
  );
};

export default EventPage;